<script>
	import { toDate } from '../global.js'

	export let item = {}

	function imprimir(){
		window.print()
	}

</script>

<div class="overlay" style="">
		<div class="no-print" style="text-align: center;position: sticky;position: -webkit-sticky;top:2px">
			<button on:click={imprimir}>Imprimir</button>
			<slot></slot>
		</div>
	<div class="main" style="max-width: 210mm;padding:1rem;margin:0 auto;">
	  	<section>
			<div style="padding:.5em .5em .1em;border:solid 2px black;border-radius: .4em;margin-bottom:1.2rem;width:100%;">
				<img src="img/logo2.png" height="90mm" alt="" style="float:left;">
				<h5 style="text-align:center;">Voucher de Ingreso</h5> 
				<!-- <div style="text-align:center;font-size:.8em;">.</div> -->
				<div style="text-align:center;font-size:.8em;">(NO VALIDO PARA INGRESO A LOS COMPLEJOS)</div>
				<h6 style="text-align:right;">N&deg; Reserva {item.IdVoucher}</h6> 
			</div>

			<div class="grid col-3">
				<span>Motivo Uso</span>
				<span>Socio/Cliente</span>
				<span>N&deg;Intercambio</span>
				<div>{item.TipoAgente}</div>
				<div>{item.IdClienteUsuario}</div>
				<div>{item.NroIntercambio}</div>
			</div>

			<div class="grid col-2">
				<span>Nombre</span>
				<span>Telefono</span>
				<div>{item.ClienteUsuario}</div>
				<div class="col-4">&nbsp;
					{item.TelefonoComercial||''}
					{item.TelefonoCelular?'  '+item.TelefonoCelular:''}
					{item.TelefonoParticular?'  '+item.TelefonoParticular:''}
				</div>
			</div>

			<div class="grid col-1">
				<span>Domicilio</span>
				<div>&nbsp;{item.Domicilio1||''} {item.Domicilio2||''}</div>
			</div>

			<div class="grid col-2">
				<span>Complejo</span>
				<span>Email</span>
				<div>&nbsp;{item.Denominacion}</div>
				<div>&nbsp;{(item.email||'').trim()}</div>
			</div>

			<div class="grid col-2">
				<span>Año de uso</span>
				<span>Capacidad</span>
				<div>{item.AnosUso}</div>
				<div>{item.Adultos+item.Menores} PAX (UH{item.Unidad})</div>
			</div>

			<div class="grid col-2">
				<span>Fecha Ingreso</span>
				<span>Fecha Egreso</span>
				<div>{toDate(item.Llegada).fecha} 16:00</div>
				<div>{toDate(item.Salida).fecha} 10:00</div>
			</div>

			<div class="grid col-1">
				<span>Observaciones</span>
				<div>&nbsp;{item.Observacionvoucher}</div>
			</div>

			<div class="grid col-1">
				<span>Emision</span>
				<div>&nbsp;{toDate(item.FechaVoucher).fecha}</div>
			</div>

			<div class="grid col-1">
				<div>Contacto:reservas@rinconclub.com.ar</div>
			</div>

			<div class="grid col-2" style="margin:3.5rem 2.5rem 1rem;grid-column-gap:4rem;width:100%;">
				<span></span>
				<span></span>
				<div style="text-align:center;font-size:1rem;">Firma Titular</div>
				<div style="text-align:center;font-size:1rem;">Firma Administracion RC</div>
			</div>

			
			<div style="width:100%;text-align: justify;">
				<p><b>IMPORTANTE: Leer atentamente</b></p>
				<ul>
					<li>Verifique que la informacion del voucher (Resort, capacidad, fechas) correspondan a su solicitud.</li>
					<li>Este voucher es INTRANSFERIBLE. Solo v&aacute;lido para uso del titular del mismo. Deber&aacute; ser presentado en la recepcion del Resort, justo con su documento.</li>
					<li>En el checkin deber&aacute;n registrarse todos los ocupantes de la unidad.</li>
					<li>En caso de retrasos en el horario o d&iacute;a de ingreso, solicitamos se contacte con el Resort, para una mejor coordinaci&ooacute;n de su ingreso. Rinc&oacute;n de los Andes: +54&nbsp;2972&nbsp;428583. Rinc&oacute;n del Este: +598&nbsp;4248&nbsp;0840.</li>
					<li>Si por alguna circunstancia ajena a Rinc&oacute;n Club, el/los ingresan al Resort con posterioridad o egresan con anterioridad a las fechas indicadas, Rinc&oacute;n Club no reembolsar&aacute; importes, ni usos, ni puntos.</li>
					<li>Se deber&aacute; respetar la capacidad m&aacute;xima de pasajeros determinada para cada unidad. No se permitir&aacute; el ingreso de m&aacute;s pasajeros que los estipulados en el voucher.</li>
					<li>Este voucher garantiza capacidad de la unidad definida, pero no, una determinada ubicaci&oacute;n ni n&uacute;mero de unidad. La unidad ser&aacute; asignada en el check-in seg&uacute;n conveniencia de la operaci&oacute;n hotelera.</li>
					<li>Los consumos de Luz y Gas, deberan ser abonados, si correspondiera, de acuerdo al tipo de unidad ocupada, no en funcion a la cantidad de pasajeros.</li>
					<li>Todo pasajero mayor de 3 (tres) años se considera como un ocupante mas de la unidad. Para pasajeros menores de 3 (tres) años solicite, sin cargo, una cuna en recepcion (largo:90cm).</li>
					<li>No se permite el ingreso de mascotas.</li>
					<li>En caso de solicitud de anulacion de esta reserva, debera comunicarse con las oficinas de Rincon Club (tel. +54 11 4123 9200; mail: reservas@rinconclub.com.ar), la que se realizara de acuerdo a los reglamentos vigentes y/o a las condiciones de cancelacion definidas por Rincon Club.</li>
					<li>La posesion del presente voucher expresa la conformidad con los terminos y condiciones del mismo</li>
				</ul>
			</div>

			<div class="footer">
				<div class="row">
					<div class="col-6" style="border-right: solid 1mm;border-bottom:solid 2px;">
						¿Como llegar a nuestros complejos?
					</div>
					
				</div>
				<div class="row px-2">
					<div class="col-6 py-2" style="border-right: solid 1mm;">
						<div style="font-size: 0.7em;line-height: 0.8;padding-bottom:3px;">
							La informacion de ubicacion y acceso a nuestros complejos esta disponible en nuestro sitio web:
						</div>
						<div class="my-1" style="font-weight: bold;font-size: 0.7rem;line-height: 0.8;">Rincon de los Andes:<br>
							<a target="blank" style="font-size: 0.7rem;" href="https://www.rinconclub.com.ar/rincon-de-los-andes/ubicacion">www.rinconclub.com.ar/rincon-de-los-andes/ubicacion</a>
						</div>
						
						<div class="my-1" style="font-weight: bold;font-size: 0.7rem;line-height: 0.8;">Rincon del Este:<br>
							<a target="blank" style="font-size: 0.7rem;" href="https://www.rinconclub.com.ar/rincon-del-este/ubicacion">www.rinconclub.com.ar/rincon-del-este/ubicacion</a>
						</div>
							
					</div>
				
					<div class="col-6 py-2" style="font-size:0.8rem;margin-top:-20px;">
						<img src="img/travel.png" width="137px" height="60px" alt="" style="float:left; padding-right: 10px;">
						Si desea contratar o consultar servicios de traslados, alquiler de vehiculos, pases o equipamientos de esqui puede contactarnos a:
						<table style="width:100%;margin-top:-15px;">
							<tr><td>&nbsp;</td></tr>
							<tr>
								<td nowrap style="font-size:0.8rem;">&#9993; info@rincontravel.com.ar</td>
								<td nowrap style="font-size:0.8rem;text-align:right;">&phone; +54 11 4123 9262</td>
							</tr>
						</table>
					</div>
				</div>
				<div class="row">
					<div class="col-12 px-4 py-1" style="font-size:0.7rem;line-height:0.9;border-top:solid 1px;">
						En caso de incumplimiento del operador turistico con el servicio ofrecido y contratado, podra recurrirse a la Secretaria de Turismo de la Nacion sita en Suipacha 1111, piso 21&deg; Telefono (5411) 4312-2232; y/o a la Direccion Nacional de Defensa del Consumidor sita en Av. Julio A. Roca N&deg; 651 piso 4&deg; - Telefono 0800-6661518.
					</div>
				</div>
			</div>
	  	</section>

	</div> 

</div>

<style>
	.main{
		position: relative;
		background-color:#fff;
		overflow: auto;
		height: 100%;
	}
	div,section,main{ box-sizing: border-box; }
	.grid{display: grid;margin: 0rem .1rem; padding:0 .1rem; width: 100%;}
	.col-3{grid-template-columns: repeat(3, 1fr);}
	.col-2{grid-template-columns: repeat(2, 1fr);}
	.col-1{grid-template-columns: 1fr;}
	.grid>span{ font-size: 0.7rem; color:#888; border-bottom:solid .7px #888;}
	.grid>div{ font-size: 0.9rem;  }
	nav{display:flex;padding-bottom: 1em; justify-content: flex-end;border: none;width: 100%;}
	li{
		line-height: 1;
		letter-spacing: 0px;
		font-size: 0.7em;
	}
	.reverse{
		color: white;
		background-color:#000; 
		display: inline;
		padding: 0.2rem 0;
		font-size: 1.2em;
		margin-top:10mm;
		margin-left: 0;
		font-stretch: expanded;
		padding: .2rem 1rem;
	}
	@media print{
		.no-print{ display: none !important; }
		.footer{ font-size: 0.7rem;
		}
		.main{
			height: 100%;
			padding: 0;margin: 0;
		}
		.reverse{
			color: black;
			background-color:white; 

		}
		a {
			border: none;
		}
	}
	section{
		height: 100%;
		width: 100%;
	}
	.footer{
		position: absolute; left: 0; top: 220mm;
		width: 100%;
		border:solid 1mm black;box-sizing: border-box;
		/*padding-top:0.20rem;*/
		/*padding:.5em .5em;*/
	}
	a {
	  color: blue;
	  text-decoration: none; /* no underline */
	  border: none;
	}
</style>